import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3.84 5.49l7.29 12.96c.38.68 1.36.68 1.74 0l7.29-12.96c.38-.67-.11-1.49-.87-1.49H4.71c-.76 0-1.25.82-.87 1.49zM6.38 6h11.25L12 16 6.38 6z"
}), 'DetailsRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DetailsRounded.js
// module id = 3115
// module chunks = 2